import {Component, Input} from '@angular/core';
import {SubscriberService} from "../../services/subscriber.service";
import {Subscription} from "rxjs";
import {SubscriptionStatus} from "../../model/subscription-status";

@Component({
    selector: 'app-main-page-subscription-select',
    templateUrl: './main-page-subscription-select.component.html',
    styleUrls: ['./main-page-subscription-select.component.css']
})
export class MainPageSubscriptionSelectComponent {
    @Input() privet: boolean;
    @Input() privetPlus: boolean;
    subscription: Subscription;

    constructor(private readonly subscriberService: SubscriberService) {
        this.subscription = new Subscription();
    }

    activatePrivetPlus(): void {
        this.subscriberService.activateSubscriptionMainPage(true);
    }

    activatePrivet(): void {
        this.subscriberService.activateSubscriptionMainPage(false);
    }

    protected readonly SubscriptionStatus = SubscriptionStatus;
}
